import { useStore } from '../hooks/useStore.js';
import './sync-indicator.css';

/**
 * Whether your edits actually landed.
 *
 * Optimistic UI means the screen updates before the write succeeds, so without
 * this there's no way to distinguish "saved" from "silently failing forever".
 * Idle renders nothing — it should be invisible until it has something to say.
 */
export function SyncIndicator() {
  const store = useStore();

  if (store.status === 'idle') return null;

  if (store.status === 'error') {
    return (
      <div class="hud-sync hud-sync--error" role="status">
        <span class="hud-sync__dot" />
        Not saved — {store.error}
        <button type="button" onClick={() => void store.flush()}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <div class="hud-sync" role="status">
      <span class="hud-sync__dot" />
      Saving{store.pendingCount > 1 ? ` ${store.pendingCount} changes` : ''}…
    </div>
  );
}
